import "core-js/modules/es.array.push.js";
import useBreadcrumbs from '@/composables/breadcrumbs/useBreadcrumbs';
import { buildBreadcrumbs } from '@/composables/breadcrumbs/buildBreadcrumbs.mjs';
import WorkCenterNameQuery from '@/graphql/work-center-info/WorkCenterName.query.gql';
export default {
  name: 'bee-breadcrumbs',
  props: {
    additionalCrumbs: {
      type: Array
    },
    breadCrumbsClass: {
      type: String
    }
  },
  apollo: {
    workCenterName: {
      query: WorkCenterNameQuery,
      variables() {
        return {
          queryParams: {
            workCenterUuid: this.workCenterUuid
          }
        };
      },
      update(data) {
        return data?.workCenter?.name || '';
      },
      skip() {
        return !this.workCenterUuid;
      }
    }
  },
  data() {
    return {};
  },
  computed: {
    hasSectionBreadcrumb() {
      return Boolean(this.$route.meta?.breadcrumb?.leafTranslationKey);
    },
    workCenterUuid() {
      return this.$route.params.workCenterUuid;
    },
    breadCrumbs() {
      return buildBreadcrumbs({
        path: this.$route.path,
        additionalCrumbs: this.additionalCrumbs,
        breadcrumb: this.$route.meta?.breadcrumb,
        workCenterUuid: this.workCenterUuid,
        workCenterName: this.workCenterName
      });
    }
  },
  methods: {
    isDisabledBreadcrumb(crumb) {
      return useBreadcrumbs().isDisabledBreadcrumb(crumb);
    },
    clickOnBreadcrumb(crumb) {
      if (this.$listeners && this.$listeners.clickOnBreadcrumb) {
        this.$emit('clickOnBreadcrumb', crumb, () => {
          this.clickOnBreadcrumbBase(crumb);
        });
        return;
      }
      this.clickOnBreadcrumbBase(crumb);
    },
    clickOnBreadcrumbBase(crumb) {
      if (this.isDisabledBreadcrumb(crumb)) {
        return;
      }
      this.$router.push({
        path: crumb.href
      });
    }
  }
};